// extracted by mini-css-extract-plugin
export var finalPrice = "style-module--finalPrice--63499";
export var oldPrice = "style-module--oldPrice--02ce8";
export var reduction = "style-module--reduction--9599f";
export var reductionValue = "style-module--reductionValue--39f79";
export var totalPrice = "style-module--totalPrice--8173a";